export const COLOR = {
  VERD: "#84CC9B",
  VERD_LIGHT: "#B2E4C3",
  VERD_DARK: "#5DB77A",
  TARONJA: "#FFC876",
  TARONJA_LIGHT: "#F6DBB2",
  TARONJA_DARK: "#FEAC32",
  VERMELL: "#FF7676",
  VERMELL_LIGHT: "#FA9E9E",
  VERMELL_DARK: "#ED5A5A",
  VERMELL_MIDDLE: "#ff9d76",
  FILTER: "#84CC9B", // #0d6efd azul bootstrap
};

export const STYLE = {
  BORDER_RADIUS: "1rem",
}